import { ITopic } from './interfaces/topic.interface';

export class Topic implements ITopic {
    id?: number;
    name: string;
    type?: string;
    externalId?: string;
}
